const actionType = {
    GET_ALL_RECON_CONFIGURATION_SUCCESS: 'GET_ALL_RECON_CONFIGURATION_SUCCESS',
    GET_RECON_CONFIGURATION_SUCCESS: 'GET_RECON_CONFIGURATION_SUCCESS',
    GET_RECON_CONFIGURATION_SUCCESS_FOR_SIDEBAR: 'GET_RECON_CONFIGURATION_SUCCESS_FOR_SIDEBAR',
    GET_RECON_DEFAULT_MAPPING_SUCCESS: 'GET_RECON_DEFAULT_MAPPING_SUCCESS',
    GET_GROUP_SOURCE_NAME_MAPPINGS: 'GET_GROUP_SOURCE_NAME_MAPPINGS',
    GET_RECON_SOURCE_FILTER_SUCCESS: 'GET_RECON_SOURCE_FILTER_SUCCESS',
    GET_RECON_FIELD_MAPPING_SUCCESS: 'GET_RECON_FIELD_MAPPING_SUCCESS',
    GET_GROUP_SOURCE_FIELD_MAPPINGS_SUCCESS: 'GET_GROUP_SOURCE_FIELD_MAPPINGS_SUCCESS',
    GET_GROUP_SOURCE_FIELD_SQL_EXPRESSION_SUCCESS: 'GET_GROUP_SOURCE_FIELD_SQL_EXPRESSION_SUCCESS',
    GET_RECON_CALCULATION_FILTER_SUCCESS: 'GET_RECON_CALCULATION_FILTER_SUCCESS',
    SET_IS_SHOW_MODAL: 'SET_IS_SHOW_MODAL',

    GET_RECON_SOURCE_AGGREGATION_RESULT: 'GET_RECON_SOURCE_AGGREGATION_RESULT',
    GET_GROUP_SOURCE_LOOKUP_CONFIGURATION_SUCCESS: 'GET_GROUP_SOURCE_LOOKUP_CONFIGURATION_SUCCESS',

    GET_RECON_SUMMARY_TYPES: 'GET_RECON_SUMMARY_TYPES'

};
export default actionType;